import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateCropExploration } from "services";

import { GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES, UPDATE_CROP_EXPLORATIONS } from "consts";

export const useUpdateCropExploration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_CROP_EXPLORATIONS],
    mutationFn: updateCropExploration,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
